import { render, staticRenderFns } from "./TinymceEditor.vue?vue&type=template&id=8cda467a&scoped=true&"
import script from "./TinymceEditor.vue?vue&type=script&lang=js&"
export * from "./TinymceEditor.vue?vue&type=script&lang=js&"
import style0 from "./TinymceEditor.vue?vue&type=style&index=0&id=8cda467a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cda467a",
  null
  
)

export default component.exports